import { environment } from '../../../environments/environment';
/**
 * Logger that logs only in development builds
 */
var Logger = (function () {
    function Logger() {
    }
    Object.defineProperty(Logger, "log", {
        /**
         * If it's a production build return the console.log function
         * @returns {any} console.log function if it's not a production build
         */
        get: function () {
            if (!environment.production) {
                return console.log.bind(window.console);
            }
            else {
                return function () { };
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logger, "error", {
        /**
         * If it's a production build return the console.error function
         * @returns {any} console.error function if it's not a production build
         */
        get: function () {
            if (!environment.production) {
                return console.error.bind(window.console);
            }
            else {
                return function () { };
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logger, "warn", {
        /**
         * If it's a production build return the console.warn function
         * @returns {any} console.warn function if it's not a production build
         */
        get: function () {
            if (!environment.production) {
                return console.warn.bind(window.console);
            }
            else {
                return function () { };
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * If it's a production build display an alert
     * @param message Message that should be displayed
     */
    Logger.alert = function (message) {
        if (!environment.production) {
            alert(message);
        }
    };
    return Logger;
}());
export { Logger };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/shared/services/logger.service.ts.pre-build-optimizer.js